import type { FiltersGroupId } from '@/app/common/filters/core/filtersTypes.ts';

export const filterGroupTitleId = (groupId: FiltersGroupId): string => `filter-group-title-${groupId}`;
